module.exports = __webpack_public_path__ + "static/img/noimg.60201250.jpg";